'use es6';

import CRM_ICON from 'bender-url!../../img/CRM.svg'; // New as of Jan 14 2022

import JAN_2022_MARKETING_ICON from 'bender-url!../../img/MarketingHub_Icon.svg';
import JAN_2022_SALES_ICON from 'bender-url!../../img/SalesHub_Icon.svg';
import JAN_2022_SERVICE_ICON from 'bender-url!../../img/ServiceHub_Icon.svg';
import JAN_2022_CMS_ICON from 'bender-url!../../img/CMSHub_Icon.svg';
import JAN_2022_OPERATIONS_ICON from 'bender-url!../../img/OperationsHub_Icon.svg';
import Hubs from 'self-service-api/constants/Hubs';
import * as ProductLines from 'self-service-api/constants/ProductLines';
export const CRM = CRM_ICON;
export const ProductLinePageIcons = {
  [ProductLines.MARKETING]: JAN_2022_MARKETING_ICON,
  [ProductLines.SALES]: JAN_2022_SALES_ICON,
  [ProductLines.SERVICE]: JAN_2022_SERVICE_ICON,
  [ProductLines.CMS]: JAN_2022_CMS_ICON,
  [ProductLines.OPERATIONS]: JAN_2022_OPERATIONS_ICON
};
const Jan2022ProductLineIcons = {
  [ProductLines.MARKETING]: JAN_2022_MARKETING_ICON,
  [ProductLines.SALES]: JAN_2022_SALES_ICON,
  [ProductLines.SERVICE]: JAN_2022_SERVICE_ICON,
  [ProductLines.CMS]: JAN_2022_CMS_ICON,
  [ProductLines.OPERATIONS]: JAN_2022_OPERATIONS_ICON
};
export const getProductLineIcons = isUngated => {
  return isUngated ? Jan2022ProductLineIcons : ProductLinePageIcons;
};
export default {
  [Hubs.HUB_MARKETING]: JAN_2022_MARKETING_ICON,
  [Hubs.HUB_SALES]: JAN_2022_SALES_ICON,
  [Hubs.HUB_SERVICE]: JAN_2022_SERVICE_ICON,
  [Hubs.HUB_CMS]: JAN_2022_CMS_ICON,
  [Hubs.HUB_OPERATIONS]: JAN_2022_OPERATIONS_ICON,
  // This is a legacy Icon as of Jan 2022. We should remove references to it and then delete.
  crm: CRM_ICON
};